import { render, staticRenderFns } from "./ECSetting.vue?vue&type=template&id=339a805e&"
import script from "./ECSetting.vue?vue&type=script&lang=ts&"
export * from "./ECSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports